import { StatusVariant } from '@factorialco/f0-react'
import {
  IntegrationsJoinOrderStatusesEnum,
  IntegrationsJoinPremiumOfferTypesEnum,
  IntegrationsJoinPremiumPostingStatusesEnum,
} from 'generated/resources/graphql'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

export const getOrderStatusColor = (status: IntegrationsJoinOrderStatusesEnum): StatusVariant => {
  switch (status) {
    case 'rejected':
    case 'failed':
    case 'cancelled':
      return 'critical'
    case 'approved':
      return 'positive'
    case 'processing':
      return 'info'
    default:
      return 'warning'
  }
}

export const getPremiumOfferTypeLabel = (type: IntegrationsJoinPremiumOfferTypesEnum) => {
  switch (type) {
    case 'bundle':
      return i18n.t('ats.purchase_requests_page.common.bundle')
    case 'product':
      return i18n.t('ats.purchase_requests_page.common.product')
  }
}

export const getPremiumPostingStatusLabel = (
  status: IntegrationsJoinPremiumPostingStatusesEnum
) => {
  switch (status) {
    case 'pending':
      return i18n.t('ats.job_details.premium_portals.statuses.pending')
      break
    case 'processing':
      return i18n.t('ats.job_details.premium_portals.statuses.processing')
      break
    case 'posted':
      return i18n.t('ats.job_details.premium_portals.statuses.posted')
      break
    case 'unposted':
      return i18n.t('ats.job_details.premium_portals.statuses.unposted')
      break
    case 'expired':
      return i18n.t('ats.job_details.premium_portals.statuses.expired')
      break
    case 'archived':
      return i18n.t('ats.job_details.premium_portals.statuses.archived')
      break
    default:
      return status
  }
}

export const getPremiumPostingStatusColor = (
  status: IntegrationsJoinPremiumPostingStatusesEnum
): StatusVariant => {
  switch (status) {
    case 'posted':
      return 'positive'
    case 'pending':
    case 'processing':
      return 'info'
    case 'expired':
      return 'critical'
    case 'unposted':
      return 'critical'
    default:
      return 'warning'
  }
}

export const getDatesRange = (from: string | null | undefined, to: string | null | undefined) => {
  if (!from || !to) return '-'

  return `${dateBackendDateTimeToUI(from)} - ${dateBackendDateTimeToUI(to)}`
}
